import {
    BanknotesIcon,
    CalendarDaysIcon,
    ClockIcon,
    MapIcon,
    ShieldCheckIcon,
    SparklesIcon,
    WifiIcon,
} from "@heroicons/react/24/outline";
import { Coffee } from "react-feather";

function HighlightIcon({ iconName }: { iconName: string }) {
    switch (iconName) {
        case "heroicon.calendar-days":
            return <CalendarDaysIcon className="size-6" />;
        case "heroicon.clock":
            return <ClockIcon className="size-6" />;
        case "heroicon.banknotes":
            return <BanknotesIcon className="size-6" />;
        case "heroicon.shield-check":
            return <ShieldCheckIcon className="size-6" />;
        case "heroicon.sparkles":
            return <SparklesIcon className="size-6" />;
        case "heroicon.wifi":
            return <WifiIcon className="size-6" />;
        case "heroicon.map":
            return <MapIcon className="size-6" />;
        case "feathericons.coffee":
            return <Coffee size={24} />;
        default:
            return null;
    }
}

interface HighlightInterface {
    legend: string;
    component: string;
    body: string;
}

export default function Highlights({
    highlights,
}: {
    highlights: HighlightInterface[];
}) {
    return (
        <div className="pb-6 px-6 sm:px-0 sm:mt-12 sm:pb-12 border-b border-b-gray-300 grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-6">
            {highlights.map((item) => (
                <div className="flex items-start space-x-4" key={item.legend}>
                    <div className="flex-none">
                        <div className="flex items-center justify-center size-16 rounded-md bg-gray-100">
                            <HighlightIcon iconName={item.component} />
                        </div>
                    </div>
                    <div>
                        <h4 className="font-semibold pt-2 pb-1">
                            {item.legend}
                        </h4>
                        <div
                            className="font-light leading-5"
                            dangerouslySetInnerHTML={{ __html: item.body }}
                        />
                    </div>
                </div>
            ))}
        </div>
    );
}
